import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

import CheckItem from 'Components/CheckItem/CheckItem'
import PropTypes from 'prop-types'
import { modalCheckupState } from 'Components/ModalCheckup/recoil/state'
import DynamicFieldPreHeader from './DynamicFieldPreHeader'
import DynamicFieldSubject from './DynamicFieldSubject'
import DynamicFieldBody from './DynamicFieldBody'
import { Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'

const DynamicFieldCheck = ({ messageType, isBee, idMessage, idCampaign }) => {
  const intl = useIntl()
  const [
    { dynamicFieldsOptionEnabled, wrongDynamicTags },
    setModalState
  ] = useRecoilState(modalCheckupState)

  const wrongDynamicTagsGroup =
    wrongDynamicTags &&
    wrongDynamicTags.reduce((a, item) => {
      a[item.Location] = a[item.Location] || []
      a[item.Location].push(item)
      return a
    }, Object.create(null))

  const handleClose = () => {
    setModalState(prev => ({
      ...prev,
      show: false
    }))
  }

  const propsOptionEnabled = () => ({
    itemKey: 'item-opt-enabled',
    icon: 'alert',
    badge: intl.formatMessage({
      id: 'Load.EmailCheckUp.WarningLabel'
    }),
    title: intl.formatMessage({
      id: 'Load.EmailCheckUp.DynamicFieldsOptDisabled'
    }),
    description: intl.formatMessage(
      {
        id: 'Load.EmailCheckUp.SummaryDynamicTagsAlert1Intl'
      },
      {
        link: e => (
          <Link
            variant={LINK_VARIANT_EXTRALIGHT}
            key='tag-alert-link'
            onClick={handleClose}
          >
            {e}
          </Link>
        ),
        br: <br key='tag-alert-br' />,
        strong: tokens => <strong key='tag-alert-strong'>{tokens}</strong>
      }
    )
  })

  return (
    <div className='c-dynamic-field-check'>
      {dynamicFieldsOptionEnabled && <CheckItem {...propsOptionEnabled()} />}
      {wrongDynamicTags && wrongDynamicTags.length > 0 && (
        <>
          <DynamicFieldPreHeader
            wrongDynamicTagsGroup={wrongDynamicTagsGroup}
          />
          <DynamicFieldSubject wrongDynamicTagsGroup={wrongDynamicTagsGroup} />
          <DynamicFieldBody
            messageType={messageType}
            isBee={isBee}
            idMessage={idMessage}
            idCampaign={idCampaign}
            wrongDynamicTagsGroup={wrongDynamicTagsGroup}
          />
        </>
      )}
    </div>
  )
}

DynamicFieldCheck.propTypes = {
  messageType: PropTypes.any,
  isBee: PropTypes.bool,
  idMessage: PropTypes.number,
  idCampaign: PropTypes.number
}

export default DynamicFieldCheck
